import { render, staticRenderFns } from "./SearchSummaryMobile.vue?vue&type=template&id=530ecdea"
import script from "./SearchSummaryMobile.vue?vue&type=script&lang=js"
export * from "./SearchSummaryMobile.vue?vue&type=script&lang=js"
import style0 from "./SearchSummaryMobile.vue?vue&type=style&index=0&id=530ecdea&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports